import React from 'react'
import PropTypes from 'prop-types'

import Form from 'component/utils/Form'
import Modal from 'component/utils/Modal'



const FIELDS = ['idSourceDepositList', 'idDestinationDepositList']

const MissionBlockEditModal = ({
  closeModal,
  depositList,
  fields,
  initialValues,
  setValueToField,
  submit,
  translate,
  values,
}) => {

  const renderOptions = (idDepositList, field, id) => {
    const renderOption = (deposit) => {
      const { idDeposit } = deposit

      const currentValue = values[field]

      const checked = idDepositList.some((depositId) => depositId === idDeposit)

      return (
        <div className='stock-transfer-options' onClick={() =>
          setValueToField(
            fields[field].input.name,
            checked
              ? currentValue.filter((i) => i !== idDeposit)
              : [...currentValue, idDeposit]
          )
        }>
          <label
          key={idDeposit}

          style={{ display: 'block', fontSize: '16px', lineHeight: '19px', color: checked ? 'black' : "#222020",  margin: '.5rem auto', fontWeight: checked ? 'bold' : 'normal' }}
        >
          {`${deposit.idDeposit} - ${deposit.dsDeposit}`}
        </label>
          <input className='stock-transfer-checkbox margin-right' type={"checkbox"} value={checked} checked={checked} />

        </div>

      )
    }

    return (
      <>
        <strong style={{ display: 'block', margin: '1rem auto', color: '#222020', fontSize: '16px', lineHeight: '19px' }}>
          {translate(`stockTransfer.missionBlock.${id}.old`)}
        </strong>
        {depositList.map(renderOption)}
      </>
    )
  }

  const isDisabled = () => {
    const initialIdSourceDepositList = initialValues.idSourceDepositList
    const initialIdDestinationDepositList =
      initialValues.idDestinationDepositList

    const currentIdSourceDepositList = values.idSourceDepositList
    const currentIdDestinationDepositList = values.idDestinationDepositList

    const compare = (array1, array2) =>
      array1.length !== array2.length ||
      array1.some((item) => !array2.includes(item))

    return !(
      compare(initialIdSourceDepositList, currentIdSourceDepositList) ||
      compare(initialIdDestinationDepositList, currentIdDestinationDepositList)
    )
  }

  return (
    <Modal
      closeModal={closeModal}
      size='md'
      className='mission-block-edit-modal mission-edit-modal-new'
    >
      <h3 style={{fontSize: '24px'}}>
        <strong style={{color: 'black'}}>{translate('stockTransfer.missionBlock.modal.title')}</strong>
      </h3>
      <p>
        <strong style={{color: '#222020', fontSize: '14px', lineHeight: '17px', fontWeight: '600'}}>{initialValues.dsMission}</strong>
      </p>
      <p>
        <span style={{color: '#222020', fontSize: '16px'}}  >{translate('stockTransfer.missionBlock.modal.text')}</span>
      </p>
      <section style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
        <div>
          {renderOptions(
            values.idSourceDepositList,
            'idSourceDepositList',
            'source'
          )}
        </div>
        <div>
          {renderOptions(
            values.idDestinationDepositList,
            'idDestinationDepositList',
            'destination'
          )}
        </div>
      </section>
      <div className='mission-block-new-modal-actions'>

          <button
            disabled={isDisabled()}
            onClick={() => submit(values)}
            className='mission-save'
          >
            {translate('save_button_label')}
          </button>

          <button
            onClick={() => closeModal()}
            className='mission-cancel'
          >
          {translate('cancel_button')}
          </button>


      </div>
    </Modal>
  )
}

MissionBlockEditModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  depositList: PropTypes.array.isRequired,
  fields: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  setValueToField: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
}

export default Form({ fields: FIELDS })(MissionBlockEditModal)

export { MissionBlockEditModal }
